import { render, staticRenderFns } from "./DashboardDownload.vue?vue&type=template&id=32dbafa2&scoped=true"
import script from "./DashboardDownload.vue?vue&type=script&lang=js"
export * from "./DashboardDownload.vue?vue&type=script&lang=js"
import style0 from "./DashboardDownload.vue?vue&type=style&index=0&id=32dbafa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dbafa2",
  null
  
)

export default component.exports